import { render, staticRenderFns } from "./embedded-chat-interface.vue?vue&type=template&id=5c9305b6&scoped=true&"
import script from "./embedded-chat-interface.vue?vue&type=script&lang=js&"
export * from "./embedded-chat-interface.vue?vue&type=script&lang=js&"
import style0 from "./embedded-chat-interface.vue?vue&type=style&index=0&id=5c9305b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9305b6",
  null
  
)

export default component.exports